
import React, { useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import gsap from "gsap";
export const Docbenifits = () => {

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  useEffect(() => {
    const hoverAnimation = (ref) => {
      gsap.to(ref, {
        scale: 1.3,
        duration: 0.2,
        onComplete: () => {
          gsap.set(ref, { scale: 1 });
        },
      });
    };

    const unhoverAnimation = (ref) => {
      gsap.to(ref, {
        scale: 1,
        duration: 0.1,
      });
    };

    const addHoverListeners = (ref) => {
      const element = ref.current;
      if (element) {
        element.addEventListener("mouseenter", () => hoverAnimation(element));
        element.addEventListener("mouseleave", () => unhoverAnimation(element));
      }
    };

    const removeHoverListeners = (ref) => {
      const element = ref.current;
      if (element) {
        element.removeEventListener("mouseenter", () => hoverAnimation(element));
        element.removeEventListener("mouseleave", () => unhoverAnimation(element));
      }
    };

    addHoverListeners(ref1);
    addHoverListeners(ref2);
    addHoverListeners(ref3);
    addHoverListeners(ref4);
    addHoverListeners(ref5);
    return () => {
      removeHoverListeners(ref1);
      removeHoverListeners(ref2);
      removeHoverListeners(ref3);
      removeHoverListeners(ref4);
      removeHoverListeners(ref5);
    };
  }, []);
  return (
    <div id='services' className='text-center' style={{overflow:"hidden"}}>
      <div className='container'>
        <div className='section-title' data-aos='fade-up' >
          <h2>How GyanBuddy KMS Benefits Your Organization</h2>
        </div>
        <div className='row' data-aos='fade-up'

        >
          <div  ref={ref1} className='col-md-6'>
         


              <i className="fa fa-signal"></i>



              <div  className='service-desc' data-aos='fade-up'>
                <h3>Improved Knowledge Sharing and Accessibility</h3>
                <p> Break down information silos and empower employees to find the knowledge they need to excel</p>
              </div>
       
          </div>

          <div  ref={ref2}  className='col-md-6'>
           
              <i className="fa fa-bars"></i>
              
              <div className='service-desc' data-aos='fade-up'>
                <h3>Increased Employee Productivity</h3>
                <p> Reduce time spent searching for information and empower employees to focus on what matters most - their work.
</p>
              </div>
          
          </div>

          <div   ref={ref3}  className='col-md-6'>
           
              <i className="fa fa-sitemap"></i>
              <div className='service-desc' data-aos='fade-up'>
                <h3>Enhanced Decision-making</h3>
                <p>Make data-driven decisions with readily available knowledge at your fingertips.
</p>
              </div>
        
          </div>
          <div  ref={ref4}  className='col-md-6'>
           
              <i className="fa fa-thumbs-up"></i>
              <div className='service-desc' data-aos='fade-up'>
                <h3>Reduced Costs</h3>
                <p> Eliminate the need for expensive, siloed knowledge management solutions. GyanBuddy KMS provides a centralized, cost-effective platform.</p>
              </div>
      
          </div>
          <div  ref={ref5}  className='col-md-12'>
          
              <i className="fa fa-truck"></i>
              <div className='service-desc' data-aos='fade-up'>
                <h3>Scalability and Adaptability</h3>
                <p>GyanBuddy KMS scales alongside your organization's needs, accommodating new documents, users, and functionalities effortlessly.</p>
              </div>
          
          </div>
        </div>
      </div>
    </div>
  );
}

